import { request } from '../request';

const userApi = {
  /**
   * banner图片获取
   */
  getBannerList() {
    return request<GetBannerListResponse[]>({
      path: '/pad/settings/v1/help/banner/list',
    });
  },
  /**
   * 配置项获取
   */
  getHelpList() {
    return request<GetHelpListResponse[]>({
      path: '/pad/settings/v1/help/list',
    });
  },
};

export default userApi;
